export const STATUS_MAP = {
  'disabled': { label: "Disabled", color: "#6c757d" },
  'disconnected': { label: "Disconnected", color: "#dca235ff" },
  'clogged': { label: "Clogged", color: "#fd7e14" },
  'looped': { label: "Looped", color: "#da07ffff" },
  'unused': { label: "Unused", color: "#c7d7d9" },
  'stuck': { label: "Stuck", color: "#b8172fff" },
  'new_sensor': { label: "New Sensor", color: "#28a745" },
  'no_sensor': { label: "No Sensor", color: "#e83e8c" },
  'no_water': { label: "No Water", color: "#3e44e8" },
  'wizard': { label: "Wizard Active", color: "#6610f2" },
  'out_of_order': { label: "Out Of Order", color: "#FC664E" },
  'manual_flush': { label: "Manual Flush", color: "#25cfc4" }
};